import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { Button } from "../ui/button";
import ReferAFriend from "../ReferAFriend";

export const OrderSuccess = ({ success }) => (
  <main className="py-20">
    <div className="max-w-2xl mx-auto px-4 text-center">
      <div className="w-20 h-20 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center mx-auto mb-6">
        <CheckCircle2 size={44} />
      </div>
      <h1 className="font-display text-4xl font-bold text-knight-navy mb-3" data-testid="order-success-heading">Order received!</h1>
      <p className="text-knight-navy/70 mb-2">Order ID: <span className="font-mono font-semibold" data-testid="order-success-id">{success.orderId}</span></p>
      <p className="text-knight-navy/70 mb-8">A confirmation email is on its way to <span className="font-semibold text-knight-navy">{success.customer.email}</span>. A specialist will reach out within 24 business hours to begin your audit.</p>
      <div className="flex gap-3 justify-center">
        <Link to="/"><Button variant="outline" className="border-knight-navy text-knight-navy">Back to Home</Button></Link>
        <Link to="/contact"><Button className="bg-knight-navy hover:bg-knight-navy-dark text-white">Contact Us</Button></Link>
      </div>

      <ReferAFriend referrerName={success.customer.first_name} />
    </div>
  </main>
);
